import { useSecondaryMenu } from 'ui/components/BPLayout'

import { useGetCompanyDetailsWebPage } from '../../Routes/CompanyDetails/hooks'

export const CompanySideBar = () => {
  const { data } = useGetCompanyDetailsWebPage()

  useSecondaryMenu([
    { label: 'General Information', hash: 'general' },
    { label: 'Documents', hash: 'documents' },
    { label: 'Contacts', hash: 'contacts' },
    ...(data?.showQuarterlyAnalytics ? [{ label: 'Quarterly Analytics', hash: 'qr' }] : []),
    ...(data?.showHighRiskReview ? [{ label: 'High-Risk Review', hash: 'hrr' }] : []),
    { label: 'Affiliated Companies', hash: 'affiliated' },
    { label: 'Licenses', hash: 'licenses' },
    { label: 'Customers', hash: 'customers' },
    { label: 'Bank Accounts', hash: 'bank-accounts' },
    { label: 'Vendors', hash: 'vendors' },
    ...(data?.showAnnualReviews ? [{ label: 'Annual Reviews', hash: 'annual' }] : []),
    ...(data?.showAdverseMedia ? [{ label: 'Adverse Media', hash: 'adverse' }] : []),
    { label: 'History', hash: 'history' }
  ])

  return null
}
